import React from 'react';
//import { Dropdown } from '../../common/elements/Dropdown';
import Select from '../../common/elements/Select';

/*const renderPaymentMethods = item => {
	if (!!item.registrationMetadata)
		return (
			<span>
				{item.registrationMetadata.issuer} ({item.registrationMetadata.subject})
			</span>
		);

	return <span>{item.title}</span>;
};*/

export const PaymentMethodsDropdown = props => {
	const {
		paymentMethods,
		onSelectPaymentMethod,
		isLoadingPaymentMethods = false,
		style,
		className,
	} = props;

	if (isLoadingPaymentMethods)
		return <div>Laddar betalningsmetoder...</div>;

	return (
		<>
			<Select
				id="paymentMethods"
				items={(paymentMethods || []).map(pm => {
					const issuer = pm.registrationMetadata && pm.registrationMetadata.issuer;
					const subject = pm.registrationMetadata && pm.registrationMetadata.subject;

					const fallbackTitle =
						issuer && subject
							? `Payment_Card_${issuer}_${subject}`
							: issuer
								? `Payment_Card_${issuer}`
								: 'Payment_Card';

					return {
						title: pm.name && pm.name.trim() ? pm.name : fallbackTitle,
						id: pm.id,
						registrationMetadata: pm.registrationMetadata || null,
					};
				})}
				onSelect={onSelectPaymentMethod}
				style={style}
				className={className}
			/>
		</>
	);
};
